import React, { useRef, useState, useEffect, useReducer } from 'react';
import { injectIntl } from 'react-intl';

import ActionLink from '../../components/builder/ActionLink.js';
import ConfirmButton from '../../components/builder/ConfirmButton.js';
import Spinner from '../../components/builder/Spinner';

import PromoColsWrapper from '../../components/front/PromoColsWrapper';

import TeamCanvas from '../../components/games/TeamCanvas.js';
import TeamClient, { TeamSuccess, TeamPublicShare, TeamPublicStats, TeamFinalWinner } from '../TeamClient.js';

const standard_board_size = 600;	// px

const reducer = (state, action) => {
	switch (action.type) {
		case 'SET_CURRENT':
			return {
				...state,
				current:action.current,
				players:((action.current == 'chose_team') ? {} : state.players),
			};

		case 'CHOSE_TEAM':
			return {
				...state,
				current:'chose_team',
				previous_players:{...state.players},
				players:{},
				current_team:0,
			};

		case 'POSITION_TEAM':
			return {
				...state,
				current:'position_team',
				players:(action?.override == true) ? {...action.players} : {...state.players,...action.players},
			};

		case 'SUCCESS_TEAM':
			return {
				...state,
				current:'success',
				result:action.result,
				image:action.image,
			};

		case 'NEXT_TEAM':
			return {
				...state,
				current_team:state.current_team+1,
				players:{...state.players,...action.players},
			};

		default:
			return state;
	}
};

const TeamStage = (props) => {
	const stage = props?.stage?.Stage ?? false;
	if(stage === false) return null;

	const [ canvas_size, setCanvasSize ] = useState(null);
	const [ in_progress, setInProgress ] = useState(false);
	const canvas = useRef(null);

	const is_builder = props?.is_builder ?? false;
	const is_editing = (is_builder) ? (props?.is_editing ?? false) : false;
	const is_playable = props?.is_playable ?? true;
	const promo = props?.promotion?.Promotion ?? false;
	const display_ui = props?.display_ui ?? true;

	const [ state, dispatch ] = useReducer(reducer, {
		current:props?.initial_state ?? 'chose_team',
		players:props.players ?? {},
		previous_players:{},
		result:false,
		current_team:props?.current_team ?? 0,
	});

	const avoid_canvas = ['success', 'public_stats', 'public_share', 'winner_team'];
	const adapt_container = (!avoid_canvas.includes(state.current)) ? true : false;

	const getCanvasSize = (num_tries) => {
		const container = document.querySelector('.gui_game_parent');
		while(num_tries > 0 && container == undefined) getCanvasSize(num_tries - 1);

		if(container != undefined) {
			const wrapper_item = document.querySelector('.flex_cols');

			if(wrapper_item != undefined) {
				const calculated_size = Math.min(container.clientWidth, wrapper_item.clientWidth);
				if(calculated_size > 250) return calculated_size;
			}
		}

		return standard_board_size;
	};

	useEffect(() => {
		if(adapt_container) {
			setTimeout(() => {
				setCanvasSize(getCanvasSize(3));
			}, 400);

			const _container = document.querySelector('.main_flex_wrapper');
			if(_container != undefined) {
				_container.classList.remove('is_game');
				_container.classList.add('is_new_game');
			}
		}
	}, []);

	useEffect(() => {
		if(!props.initial_state) return;
		dispatch({ type:'SET_CURRENT', current:props.initial_state });
	}, [ props.initial_state ]);

	useEffect(() => {
		if(!props.players) return;
		dispatch({ type:'POSITION_TEAM', override:true, players:props.players });
	}, [ props.players ]);

	useEffect(() => {
		if(is_playable && state.current == 'position_team') {
			window.scrollTo(0, 0);
		}
	}, [ state.current ]);

	useEffect(() => {
		setTimeout(() => {
			if(props.canvas_ref != undefined) props.canvas_ref(canvas.current);
		}, 500);
	}, [ canvas.current ]);

	if(promo === false) return null;

	if(state.current == 'success') {
		return (
			<TeamSuccess
				stage={stage}
				result={state.result}
				players={state.players}
				locale={props.locale}
				promotion={promo}
				participation_id={(!is_builder) ? 'test' : null}
				participation_hash={(!is_builder) ? 'test' : null}
				is_builder={is_builder}
				intl={props.intl}
			/>
		)
	}

	if(state.current == 'winner_team') {
		return (
			<TeamFinalWinner
				stage={stage}
				result={state.result}
				//players={state.players}
				locale={props.locale}
				promotion={promo}
				participation_id={(!is_builder) ? 'test' : null}
				participation_hash={(!is_builder) ? 'test' : null}
				is_builder={is_builder}
				intl={props.intl}
			/>
		)
	}

	if(state.current == 'public_stats') {
		return (
			<TeamPublicStats
				stage={stage}
				promotion={promo}
				locale={props.locale}
				is_builder={is_builder}
				intl={props.intl}
			/>
		)
	}

	if(state.current == 'public_share') {
		return (
			<TeamPublicShare
				stage={stage}
				promotion={promo}
				locale={props.locale}
				user={(!is_builder) ? 'test' : {}}
				is_builder={is_builder}
				intl={props.intl}
			/>
		)
	}

	const participate = (cb) => {
		setInProgress(true);

		const image = canvas.current.to_image();
		if(is_builder) {
			dispatch({ type:'SUCCESS_TEAM', result:{}, image });
			setInProgress(false);
			return;
		}
		
		const data = {
			team:state.players,
			image,
			ticket:props.ticket
		};

		$.post(`/promotions/participate/${promo.id}/${stage.id}`, data, (res) => {
			dispatch({ type:'SUCCESS_TEAM', result:res, image });
			setInProgress(false);
		}, 'JSON');
	};

	const position_team = (players, cb) => {
		
		if(state.current_team < stage.teams.length - 1) {
			dispatch({ type:'NEXT_TEAM', players });
			return;
		}

		dispatch({ type:'POSITION_TEAM', players});
		if(props.onTeamChosen != undefined) props.onTeamChosen(players);
		if(cb != undefined) cb();
	};

	return (
		<PromoColsWrapper>
			{(state.current == 'position_team' && display_ui) && (
				<div class="team_ctas">
					<ActionLink
						icon='knk-arrow-l-big'
						onClick={() => dispatch({ type:'CHOSE_TEAM' })}
					>Go back</ActionLink>

					<ConfirmButton
						icon='knk-arrow-r-big gui_after_icon save_team_btn'
						onClick={participate}
						type='link'
						_position='bottom'
						_class={(in_progress) ? { other:'gui_remove_pointer_events' } : null}
						disabled={(in_progress) ? true : false}
					>Confirm team</ConfirmButton>
				</div>
			)}

			<div class="gui_game_parent">
				{(state.current == 'chose_team') && (
					<TeamClient
						key={`team_${state.current_team}`}
						stage={stage}
						team={stage.teams[state.current_team]}
						players={state.previous_players}
						next={position_team}
						locale={props.locale}
						is_builder={is_builder}
						promotion={promo}
					/>
				)}

				{(state.current == 'position_team') && (
					<>
						<img src={`${window.cdn_url}img/blank_2x3.png`} width="100%" alt="" />
					
						{(canvas_size != null) ? (
							<>
								<TeamCanvas
									ref={canvas}
									user={state.players}
									canvas_size_w={canvas_size}
									canvas_size_h={canvas_size * 3 / 2}
									promotion={promo}
									stage={stage}
									areaChanged={props.areaChanged}
									is_builder={is_builder}
									is_editing={is_editing}
									is_playable={is_playable}
								/>
							</>
						) : (
							<div class="is_fullscreen relative_to_container">
								<Spinner
									color='rgba(var(--secondary-color), 1)'
									force_bg={true}
								>Loading game</Spinner>
							</div>
						)}
					</>
				)}
			</div>
		</PromoColsWrapper>
	);
}

export default injectIntl(TeamStage);